<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    class="mb40"
    :pagination="pagination"
  >
    <template v-slot:bodyCell="{ column, record }">
      <template v-if="column.dataIndex == 'remark'">
        <span v-for="(item, index) in JSON.parse(record.remark)" :key="index"
          >{{ item.key }} : {{ item.value }}<br
        /></span>
      </template>
      <template v-if="column.dataIndex == 'status'">
        <span v-if="record.status === 0">未发放</span>
        <span v-if="record.status === 1">发放中</span>
        <span v-if="record.status === 2">结束</span>
      </template>
      <template v-if="column.dataIndex == 'expStartDate'">
        {{ record.expStartDate }}~{{ record.expEndDate }}
      </template>
      <template v-if="column.dataIndex == 'operate'">
        <a-button type="link" @click="handleEdit(record)">
          编辑
        </a-button>
        <a-popconfirm title="确定删除吗?" @confirm="handleDel(record)">
          <a-button type="link">
            删除
          </a-button>
        </a-popconfirm>
      </template>
    </template>
  </a-table>
</template>

<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped></style>
